// biome-ignore lint/style/noRestrictedImports: Dialog not yet migrated from client/
import Dialog from 'client/components/core/Dialog/Dialog'
import React from 'react'

export type DialogProps = React.ComponentProps<typeof Dialog>

export { Dialog }

export const DialogBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...rest
}) => <div {...rest}>{children}</div>
